import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient } from "~/utils";

import { ResponseMessageType } from "~/domains";

type RequestDataType = {
  body: {
    email: string;
    lastName: string;
    firstName: string;
    katakanaLastName: string;
    katakanaFirstName: string;
    jobTitle: string;
    employeeRoleId: number;
    jobCategoryId: string;
    employeeCode: string;
    password: string;
    businessDivisions: { ids: string[] };
    businessSections: { ids: string[] };
  };
};

const request = ({ body }: RequestDataType) => {
  return new ApiClient()
    .post<ResponseMessageType>("/api/managers/employee/invites", {
      invite: body,
    })
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisManagersEmployeesInvitesCreate = ({
  options = {},
}: PropsType = {}): UseMutationResult<ResponseMessageType, RequestDataType> => {
  return useMutation(request, { ...options });
};
